/**
 * SG-14903 T1216 -- the card-backed trial extension opened from the day-14 email.
 */

/** The `source` core puts on the extension Checkout's success URL (`?checkout=success&source=trial_extension`). */
export const TRIAL_EXTENSION_SOURCE = 'trial_extension'

/** The typed refusals `POST /user/trial/extend-checkout` answers with (`values.code`). */
export const TrialExtensionCode = {
    UNAVAILABLE: 'trial_extension_unavailable',
    ALREADY_USED: 'trial_extension_already_used',
    TEAM_MEMBER: 'trial_extension_team_member',
    STILL_ACTIVE: 'trial_extension_still_active',
    ALREADY_PAID: 'trial_extension_already_paid',
    NOT_LAPSED: 'trial_extension_not_lapsed'
}

/** The message each refusal shows. Anything not listed (including no code at all) reads as unavailable. */
export const TRIAL_EXTENSION_MESSAGE_IDS = {
    [TrialExtensionCode.ALREADY_USED]: 'extendTrialPage.alreadyUsed',
    [TrialExtensionCode.ALREADY_PAID]: 'extendTrialPage.alreadyPaid',
    [TrialExtensionCode.TEAM_MEMBER]: 'extendTrialPage.teamMember'
}
export const TRIAL_EXTENSION_FALLBACK_MESSAGE_ID = 'extendTrialPage.unavailable'
